import React from 'react'
import get from 'lodash/get'
import { Tooltip } from '@material-ui/core'
import { PublishingLocationExpandedDTO } from '@graphics/gfx-common/dist/types'
import { IEditionMetadata, PackType } from '../../types/pack'
import * as date from '../../services/date'
import { concatenate } from '../../services/pack'
import {
  getLocationStatus,
  isLocationPublic,
  isLocationMedia,
} from '../../services/publishingLocations'
import { Space } from '../../layouts'
import { H2, P, PublishIndicator } from '../../components'
import { LocationActions } from './LocationActions'
import { StyledLocationDetail } from './styled'

export interface ILocationsDetails {
  pack: PackType
  edition: IEditionMetadata
}

export const LocationsDetails = ({ pack, edition }: ILocationsDetails) => {
  const formatDate = (dateString?: string | null) =>
    !!dateString ? date.calendar(dateString, 'SHORT') : 'Never'
  const concatenatedTitle = concatenate(pack, edition, 'title')

  // @ts-ignore
  return get(edition, 'publishing.locations', []).map(
    ({
      name,
      access,
      hosted,
      title,
      published,
      publish,
      revision = 0,
      publishedDate,
      firstPublished,
      expiryDate,
      error,
      publishedURI,
      shortURI,
      state,
      destinations = [],
    }: PublishingLocationExpandedDTO) => (
      <StyledLocationDetail key={title}>
        <header>
          <H2>{title}</H2>
          <Space pl={2}>
            <PublishIndicator
              status={getLocationStatus(published, state, error)}
            />
          </Space>
        </header>
        <P>
          {state === 'Error' ? (
            <Tooltip
              title={error?.description ?? ''}
              aria-label="publishing-error"
            >
              <span>The Graphic has not been published successfully.</span>
            </Tooltip>
          ) : published ? (
            'The Graphic has been published successfully.'
          ) : (
            'The Graphic has not been published.'
          )}
        </P>
        <section>
          <article>
            <P>
              <strong>Revisions:</strong>
              <span>{revision}</span>
            </P>
            <P>
              <strong>Published:</strong>
              <span>{formatDate(publishedDate)}</span>
            </P>
          </article>
          <article>
            <P>
              <strong>First published:</strong>
              <span>{formatDate(firstPublished)}</span>
            </P>
            {isLocationMedia(name) && (
              <>
                {destinations.length > 0 && (
                  <P>
                    <strong>Destinations:</strong>
                    <span>{destinations.join(', ')}</span>
                  </P>
                )}
              </>
            )}
            <P>
              <strong>Expires:</strong>
              <span>{formatDate(expiryDate)}</span>
            </P>
          </article>
        </section>
        {isLocationPublic(access) && hosted && (
          <footer>
            <LocationActions
              title={concatenatedTitle}
              shortURI={shortURI}
              publishedURI={publishedURI}
              published={published}
              publish={publish}
              packId={pack.id}
              editionId={edition.id}
              name={name}
            />
          </footer>
        )}
      </StyledLocationDetail>
    )
  )
}
